module.exports = __webpack_public_path__ + "static/media/step-1.093eb303.png";